import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { PaginationService } from 'libs/portal/src/services/pagination/pagination.service';
import { CardTableExpandableHeader } from '../../models/card-table-expandable-header';
import { CardTableHeader } from '../../models/card-table-header.model';
import { CardTableOptions } from '../../models/card-table-options.model';

@Component({
  selector: 'app-card-table',
  templateUrl: './card-table.component.html',
  styleUrls: ['./card-table.component.scss'],
})
export class CardTableComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() prefixTemplate: TemplateRef<any>;
  @Input() cardTemplate: TemplateRef<any>;
  @Input() rowTemplate: TemplateRef<any>;
  @Input() isExpandable = false;
  @Input() affixTemplate: TemplateRef<any>;
  @Input() headerAffixTemplate: TemplateRef<any>;

  @Input() data: any[];
  @Input() tableHeaders: CardTableHeader[];
  @Input() options: CardTableOptions;
  @Input() displayedColumns: string[] = [];
  @Input() breakpoint: ScreenSize;
  @Input() enableInfiteScroll = false;
  @Input() enableTablePagination = false;
  @Input() enableRefresher = false;
  @Input() totalItems: number;
  @Input() currentPage = 1;
  @Input() dropDownActionsTemplate: TemplateRef<any>;
  @Input() dropDownDataKey = '';
  @Input() expansionHeader: Array<CardTableExpandableHeader> = [];
  @Input() sortedIndex: number;
  @Input() originalStyling: boolean = true;
  @Input() allSelected: boolean = false;
  @Input() uniqueID: number = 1;
  isPagingComplete: boolean;
  primaryData: any[];

  @Output() rowSelectedEvent = new EventEmitter<any>();
  @Output() dataScrolledEvent = new EventEmitter<any>();
  @Output() paginateEvent = new EventEmitter<any>();
  @Output() dataRefreshedEvent = new EventEmitter<any>();
  @Output() columnSortedEvent = new EventEmitter<[CardTableHeader, number]>();
  @Output() selectAllEmitter = new EventEmitter<any>();
  @ViewChild(InfiniteScrollDirective) infiniteScroll: InfiniteScrollDirective;
  ScreenSize = ScreenSize;
  refreshing = false;
  // allSelected = false;

  constructor(public layoutService: LayoutService, private paginationService: PaginationService) { }

  ngOnInit() {
    if (this.data != null && this.data.length > 0) {
      this.isPagingComplete = true;
    }
  }

  ngAfterViewInit(): void {
    if (this.enableInfiteScroll == false && this.layoutService.screenSize > ScreenSize.MOBILE_L) {
      if (this.infiniteScroll != null) {
        this.infiniteScroll.infiniteScrollDisabled = true;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.data = changes['data'].currentValue;
    }

    if (changes['totalItems']) {
      // this.config.totalItems = changes.totalItems.currentValue;
    }

    if (changes['currentPage']) {
      // this.config.currentPage = changes.currentPage.currentValue;
    }

    if (changes['enableInfiteScroll'] && changes['enableInfiteScroll'].currentValue != null && this.infiniteScroll && this.layoutService.screenSize < ScreenSize.TABLET) {
      this.infiniteScroll.infiniteScrollDisabled = !this.enableInfiteScroll;
    }

    if (changes['allSelected'] && changes['allSelected'].currentValue !== undefined && changes['allSelected'].currentValue != this.allSelected) {
      this.toggleSelectAll(changes['allSelected'].currentValue);
    }
  }

  toggleSelectAll(selectAll: boolean): void {
    this.data.forEach(row => {
      row.selected = selectAll; // Assuming each row has a `selected` property
    });
  }

  selected($event: any) {
    if (this.options.isSelectable) {
      this.data[$event.index][this.options.selectedProperty] = !this.data[$event.index][this.options.selectedProperty];
      if (!this.data[$event.index][this.options.selectedProperty]) {
        this.allSelected = false;
      }
    }
    this.rowSelectedEvent.emit(this.data[$event.index]);
  }

  loadData($event: any) {
    this.dataScrolledEvent.emit($event);
  }

  onChangePage($event: any) {
    this.isPagingComplete = false;
    this.paginateEvent.emit($event);
    this.paginationService.paginateCompleteEvent.subscribe(() => {
      this.isPagingComplete = true;
    });
  }

  doRefresh($event: any) {
    this.dataRefreshedEvent.emit($event);
  }

  StartRefresh() {
    setTimeout(() => (this.refreshing = true));
  }

  EndRefresh() {
    setTimeout(() => (this.refreshing = false));
  }

  sort(data: [CardTableHeader, number]) {
    this.columnSortedEvent.emit([data[0], data[1]]);
  }

  selectAll(event) {
    this.allSelected = !this.allSelected;
    if (this.options.selectAll) {
      this.selectAllEmitter.emit(this.allSelected);
    }
  }
}
